// import RecykalLogoLoader from './RecykalLogoLoader';

import useLogoLoader from '../../../hooks/useLogoLoader';

const LogoLoader = (props) => {
  const {
    size = 'sm',
    className = '',
    margin = 'my-3',
    style,
    colors = {
      bottomLeft: 'black',
      bottomRight: 'black',
      topRight: 'black',
      topLeft: 'black',
    },
    animate = false,
    animateType = 'groupTogether',
    animateDuration = 1.5,
  } = props;

  //   const colors = {
  // bottomLeft: '#FFB34B',
  //   bottomRight: '#FF7E42',
  //   topRight: '#4272FF',
  //   topLeft: '#42EAFF',
  //   }, // different colors in logo
  const { loader } = useLogoLoader('normal');
  const Loader = loader;
  return (
    <div className={className} style={style}>
      <Loader />
    </div>
  );
};

export default LogoLoader;
